import { DropdownIcon } from "app/components/Icons";
import PlusIcon from "app/components/Icons/PlusIcon";
import CommonTicketTypeSelection from "app/containers/Features/components/CommonTicketTypeSelection";
import React from "react";
import { useAddTicketLogic } from "../useAddTicketLogic";
import { AddTaskProps } from "./types";

const AddTaskButton: React.FC<AddTaskProps> = ({
  setIsHovered,
  isHovered,
  groupId,
  minTableWidth,
}) => {
  const [open, setOpen] = React.useState(false);
  const { defaultTypeName, handleTicketTask, handleTicketType, selectedType } =
    useAddTicketLogic(groupId);
  return (
    <div
      className="flex flex-row items-center gap-[4px] mt-[5px] mb-[15px] group hover:bg-gray-200 h-[30px] relative"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ minWidth: minTableWidth }}
    >
      {/* Second sticky area - aligned with second column */}
      <div
        className="sticky left-[62px] bg-gray-400 group-hover:bg-gray-200 flex flex-row items-center gap-[4px] px-[4px]"
        style={{ minWidth: 747 }}
      >
        <PlusIcon color="#5A8DF1" />

        <div className="flex flex-row items-center group-hover:bg-white group-hover:border group-hover:border-gray-100 rounded-[4px]">
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleTicketTask();
            }}
            className="hover:bg-gray-200 h-[20px] px-[6px] pb-2 text-sm leading-[21px] font-medium text-primary"
          >
            Add {defaultTypeName}
          </button>

          <CommonTicketTypeSelection
            setOpen={() => {
              setOpen(!open);
            }}
            trigger={
              <button
                className={`${
                  !open ? (isHovered ? "group-hover:visible" : "invisible") : ""
                } hover:bg-gray-200 border-l border-gray-100 justify-center items-center size-[20px] rounded-r-[4px]`}
              >
                <DropdownIcon size={20} />
              </button>
            }
            value={selectedType}
            setValue={(data) => {
              handleTicketType(data?._id);
            }}
            isHeader="TICKET TYPES"
            className="!w-[237px]"
            isHeaderClassName="!text-secondary !text-sm !font-semibold "
            showDefault
            align="start"
          />
        </div>
      </div>
      {/* Scrollable area */}
      <div className="flex-1 bg-gray-400 group-hover:bg-gray-200">
        {/* Empty space for scrollable columns */}
      </div>
    </div>
  );
};

export default AddTaskButton;
